import axios from 'axios'
import qs from 'qs'
import {
  isEmpty
} from '@/js/util'
import util from '../util/util'
import newRequest from '../util/requestUtil'

let instance = axios.create({
  baseURL: process.env.VUE_APP_CLIENT_SERVER_URL
})
// axios.defaults.withCredentials=true;
function request (options) {
  options = setToken(options)
  return new Promise((resolve, reject) => {
    instance(options)
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        return reject(error.response.data)
      })
  })
}

/**
 *
 * @param {*} options
 * 200，则返回数据
 * 500，则返回{code:'',msg:''}
 */
function setRequest (options) {
  options = setToken(options)
  return new Promise((resolve, reject) => {
    instance(options)
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        return reject(error.response.data)
      })
  })
}

function setToken (options) {
  let userInfo = util.getToken()
  let baseHeader = {}

  if (userInfo && !isEmpty(userInfo.accessToken)) {
    baseHeader = {
      'X-Token': userInfo.accessToken,
      'X-Language': getLanguage()
    }
    options['headers'] = options.headers ? Object.assign(baseHeader, options.headers) : baseHeader
  }
  return options
}
function getLanguage () {
  let locale = (util.getProfile() && util.getProfile().locale) || 'cn'
  switch (locale) {
    case 'zh-hant':
      return 'hk'
    case 'zh-hans':
      return 'cn'
    default:
      return 'cn'
  }
}

function getParamsUrl (options) {
  let result = '?'
  for (let key in options) {
    if (options[key] || options[key] === 0) {
      result += (key + '=' + options[key] + '&')
    } else {
      result += (key + '=&')
    }
  }
  if (result[result.length - 1] === '&') {
    result = result.substring(0, result.length - 1)
  }
  return result
}

let api = {
  getDepositRecords: (options) => {
    let url = 'public/funds.deposits' + '?' + qs.stringify(options)
    return request({
      method: 'get',
      // url: 'deposits' + getParamsUrl(options),
      url: url,
      data: options || {}
    })
  },

  getAcountType: (options) => {
    return request({
      method: 'get',
      url: 'public/accountInfos' + getParamsUrl(options),
      data: options || {}
    })
  },
  getTradeAccountBalance: (id, options) => {
    return newRequest({
      method: 'get',
      url: 'balance' + getParamsUrl(options),
      data: options || {}
    })
  },
  getBankList: (options) => {
    return newRequest({
      method: 'get',
      url: 'client/clientInfo/getBankClientInfoTmp' + getParamsUrl(options),
      data: options || {}
    })
  },
  getCaptcha: () => {
    return request({
      method: 'get',
      url: 'bridge/captcha/getCaptcha'
    })
  },
  bondSubmit: (options) => {
    return request({
      method: 'post',
      url: '/public/bonds',
      data: options || {}
    })
  },
  getBonds: (options) => {
    return request({
      method: 'get',
      url: `/public/bonds/${options.clientId}`
    })
  },
  getBankInfo: (options) => {
    return request({
      method: 'get',
      url: 'public/bankInfos' + getParamsUrl(options),
      data: options || {}
    })
  },
  verifyEmailCode: (options) => {
    return request({
      method: 'post',
      url: 'email/verifyEmailCode',
      data: options || {}
    })
  },
  verifyCode: (options, phoneNumber) => {
    return request({
      method: 'get',
      url: `/public/verifyCode/${phoneNumber}` + getParamsUrl(options)
    })
  },
  sendEmailCode: (options) => {
    return request({
      method: 'post',
      url: 'email/sendEmailCode',
      data: options || {}
    })
  },
  getTransferRecords: (options) => {
    // return request({
    //   method: 'post',
    //   url: 'bridge/transfer/getRecords',
    //   data: options || {}
    // })
    let url = 'public/funds.transfers' + '?' + qs.stringify(options)
    return request({
      method: 'get',
      // url: 'transfers' + getParamsUrl(options),
      url: url,
      data: options || {}
    })
  },
  createTransferRecords: (options) => {
    return request({
      method: 'post',
      url: 'public/funds.transfers',
      data: options || {}
    })
  },
  createDepositRecords: (options) => {
    return request({
      method: 'post',
      url: 'public/funds.deposits',
      data: options || {}
    })
  },
  updateWithdrawalRecord: (options) => {
    return request({
      method: 'put',
      url: 'public/funds.withdrawals/' + options._id,
      data: options || {}
    })
  },
  updateTransferRecord: (options) => {
    return request({
      method: 'put',
      url: 'public/funds.transfers/' + options._id,
      data: options || {}
    })
  },
  createWithdrawalRecords: (options) => {
    return request({
      method: 'post',
      url: 'public/funds.withdrawals',
      data: options || {}
    })
  },
  createTradeProductRecords: (options) => {
    return request({
      method: 'post',
      url: 'public/tradeProducts',
      data: options || {}
    })
  },
  getTradeProductRecords: (options) => {
    return request({
      method: 'get',
      url: 'public/tradeProducts' + getParamsUrl(options),
      data: options || {}
    })
  },
  createsubAccount: (options) => {
    return request({
      method: 'post',
      url: 'public/subBankAccounts',
      data: options || {}
    })
  },
  getsubAccount: (options) => {
    let url = 'public/subBankAccounts' + '?' + qs.stringify(options)
    return request({
      method: 'get',
      // url: 'bankSubAccount' + getParamsUrl(options),
      // url: 'transection/getWithdrawalRecords',
      url: url,
      data: options || {}
    })
  },
  getsubAccountDetail: (options) => {
    return request({
      method: 'get',
      url: 'public/subBankAccounts/' + options.id + getParamsUrl(options),
      // url: 'transection/getWithdrawalRecords',
      data: options || {}
    })
  },
  getWithdrawalRecords: (options) => {
    let url = 'public/funds.withdrawals' + '?' + qs.stringify(options)
    return request({
      method: 'get',
      // url: 'withdrawals' + getParamsUrl(options),
      // url: 'transection/getWithdrawalRecords',
      url: url,
      data: options || {}
    })
  },
  getAccountInfo: (options) => {
    return request({
      method: 'get',
      url: 'public/accountInfos' + getParamsUrl(options),
      // url: 'transection/getWithdrawalRecords',
      data: options || {}
    })
  },
  changePassword: (options) => { // 自己的接口名称
    options.functionName = 'changePassword'
    return newRequest({
      method: 'put', // 请求方式
      url: `/users/updatePassword`,
      data: options || {}
    })
  },
  getLatestRecords: (options) => { // 自己的接口名称
    return request({
      method: 'get', // 请求方式
      url: 'public/transaction' + getParamsUrl(options),
      data: options || {}
    })
  },
  withdrawalRecords: (options) => { // 自己的接口名称
    return request({
      method: 'get', // 请求方式
      url: 'public/checkTransactions' + getParamsUrl(options),
      data: options || {}
    })
  },
  groupByCurrency: (options) => { // 自己的接口名称
    return request({
      method: 'get', // 请求方式
      url: 'public/currency' + getParamsUrl(options),
      data: options || {}
    })
  },
  getUserStatus: (options) => { // shelly开户资料填写状态
    options.functionName = 'getUserStatus'
    return request({
      method: 'get', // 请求方式
      url: 'public/users/' + options.idpUserId + getParamsUrl(options),
      data: options || {}
    })
  },
  changeEmail: (options) => {
    options.functionName = 'changeEmail'
    return newRequest({
      method: 'put', // 请求方式
      url: `/users/updateUserInfo`,
      data: options || {}
    })
  },
  phoneVerificationCode: (options) => {
    options.functionName = 'getPhoneVerCode'
    return request({
      method: 'get', // 请求方式
      url: 'public/users/' + options.phone_number + getParamsUrl(options),
      data: options || {}
    })
  },
  updatePhoneNum: (options) => {
    options.functionName = 'changePhone'
    return newRequest({
      method: 'put', // 请求方式
      url: `/users/updateUserInfo`,
      data: options || {}
    })
  },
  getUserByShowType: (options) => {
    options.functionName = 'getUserByShowType'
    console.log(options)
    return request({
      method: 'get', // 请求方式
      url: 'users/' + options.phone_number + getParamsUrl(options),
      data: options || {}
    })
  },
  getUserInfoByidpUserId: (options) => {
    return request({
      method: 'get', // 请求方式
      url: 'public/clientProfiles/' + options.idpUserId + getParamsUrl(options),
      data: options || {}
    })
  },
  downloadImage: (options) => {
    return request({
      method: 'get', // 请求方式
      url: 'public/images/' + options.id + getParamsUrl(options),
      data: options || {}
    })
  },
  getTradeAccountListByIdpUserId: (options) => {
    return request({
      method: 'get', // 请求方式
      url: 'public/accounts/' + options.idpUserId + getParamsUrl(options),
      data: options || {}
    })
  },
  checkSubAccountOrders (options) {
    return request({
      method: 'get',
      url: 'public/checkSubAccountOrders' + getParamsUrl(options),
      // url: 'transection/getWithdrawalRecords',
      data: options || {}
    })
  },
  changePasswordMt5 (options) {
    return request({
      method: 'put',
      url: 'public/accountInfos/' + options.login + getParamsUrl(options),
      // url: 'transection/getWithdrawalRecords',
      data: options || {}
    })
  },
  uploadImg (data) {
    const headers = { 'X-API-KEY': process.env.VUE_APP_ALI_X_API_KEY }
    // const headers = { 'X-API-KEY': '746d2291-d597-482e-a732-b6e7c67be8a2' }
    return request({
      url: process.env.VUE_APP_ALI_UPLOAD_URL + 'uploads/base64',
      headers: headers,
      method: 'post',
      data
    })
  },
  getUploadFileType () {
    return new Promise(function (resolve, reject) {
      var XHR = new XMLHttpRequest()
      XHR.open('GET', process.env.VUE_APP_GET_UPLOAD_FILE_TYPE, true)
      XHR.send()
      XHR.onreadystatechange = function () {
        if (XHR.readyState === 4) {
          if (XHR.status === 200) {
            try {
              var response = JSON.parse(XHR.responseText)
              resolve(response)
            } catch (e) {
              reject(e)
            }
          } else {
            reject(new Error(XHR.statusText))
          }
        }
      }
    })
  },
  getImage (imgKey) {
    return request({
      method: 'get',
      url: `/image/${imgKey}?key=public/${imgKey}`,
      data: imgKey
    })
  },
  getLastExchangeRate (options) {
    return request({
      method: 'get',
      url: 'public/exchange/' + options.id + getParamsUrl(options),
      // url: 'transection/getWithdrawalRecords',
      data: options || {}
    })
  },
  createExchange (options) {
    return request({
      method: 'post',
      url: 'public/exchange',
      data: options || {}
    })
  },
  getExchangeRecord (options) {
    return request({
      method: 'get',
      url: `public/exchange?${qs.stringify(options)}`,
      data: options || {}
    })
  },
  changeStockAccountPassword (options) {
    return request({
      method: 'put',
      url: '/public/updatePassword/' + options.tradeAccount,
      // url: 'transection/getWithdrawalRecords',
      data: options || {}
    })
  },
  changeFuturesAccountPassword (options) {
    return request({
      headers: { 'Platform': 'H5' }, // 设置header信息
      method: 'post',
      url: `${process.env.VUE_APP_MIDDLE_PLATFORM_SYSTEM_URL}/account/futures/changePassword`,
      data: options || {}
    })
  },
  getQuotesApplyRecords (options) {
    return request({
      method: 'get',
      url: 'public/quotes',
      params: options || {}
    })
  },
  createQuotesApply (data) {
    return request({
      method: 'post',
      url: 'public/quotes',
      data: data || {}
    })
  },
  getApplyTradeAccountType (options) {
    return request({
      method: 'get',
      url: '/public/applyTradeAccountType',
      params: options || {}
    })
  },
  getVCode (options, phoneNumber) {
    return request({
      method: 'get',
      url: `/public/vCode/${phoneNumber}` + getParamsUrl(options)
    })
  },
  getBalance (options) {
    return newRequest({
      method: 'post',
      url: 'balance/getAll',
      data: options || {}
    })
  }
}
export default api
